module.exports = __webpack_public_path__ + "static/media/cpg_desktop_vehiclerecall_banner.e2f146e0.png";